import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-distribution-preview',
  templateUrl: './distribution-preview.component.html',
  styleUrls: ['./distribution-preview.component.scss']
})
export class DistributionPreviewComponent implements OnInit {
  officeViewerUrl: SafeResourceUrl | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const distributionUrl = this.data?.url;

    if (distributionUrl) {
      const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(distributionUrl)}`;
      this.officeViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl);
    }
  }

}
